<script setup lang="ts">
/**
 * Common frame for the auth screens that lead with a heading: forgot password,
 * check your email, set a new password, link expired, password updated.
 *
 * The logo and the close button live in `AuthWrapper`; this only owns what sits
 * between them and the form. Title and subtext are one block 4px apart, and the
 * blocks around it sit on the 24px grid (`66:46916`, `66:47115`).
 */
withDefaults(defineProps<{
  title?: string
  description?: string
  /** Status screens (check email, link expired) centre their content. */
  centered?: boolean
}>(), {
  title: undefined,
  description: undefined,
  centered: false,
})
</script>

<template>
  <div :class="['fair-auth-screen', centered ? 'fair-auth-screen--centered' : '']">
    <slot name="art" />

    <div
      v-if="title || description || $slots.description"
      class="fair-auth-screen__text-block"
    >
      <h2
        v-if="title"
        class="fair-auth-screen__title"
      >
        {{ title }}
      </h2>

      <p
        v-if="description || $slots.description"
        class="fair-auth-screen__text"
      >
        <slot name="description">
          {{ description }}
        </slot>
      </p>
    </div>

    <slot />
  </div>
</template>
